import { useContext } from 'react';
import AppContext from '../../../AppContext';
import styles from './MedicalLossRatioRebatesRow.module.css';
import HeaderHelmet, { HeaderHelmetProps } from '../../SubSectionHeader/HeaderHelmet';

interface MedicalLossRatioRebatesHeaderProps {
  helmet: HeaderHelmetProps;
}

export default function MedicalLossRatioRebatesHeader({
  helmet
}: MedicalLossRatioRebatesHeaderProps) {
  const { showBenchmark } = useContext(AppContext);

  return (
    <div className={`${styles.container} ${showBenchmark ? '' : styles.collapse}`}>
      <HeaderHelmet {...helmet} />
      <h5 aria-hidden="true"></h5>
      <h5 aria-hidden="true"></h5>
      <h5 className="column_align_right">
        Ind. Curr <br /> Rpt Yr
      </h5>
      <h5 className="column_align_right">
        Ind. Prior <br /> Rpt Yr
      </h5>
      <h5 className="column_align_right">
        Small Grp. <br /> Curr Rpt Yr
      </h5>
      <h5 className="column_align_right">
        Small Grp. <br /> Prior Rpt Yr
      </h5>
      <h5 className="column_align_right">
        Large Grp. <br /> Curr Rpt Yr
      </h5>
      <h5 className="column_align_right">
        Large Grp. <br /> Prior Rpt Yr
      </h5>
      <h5 className="column_align_right">
        Other Curr <br /> Rpt Yr
      </h5>
      <h5 className="column_align_right">
        Other Prior <br /> Rpt Yr
      </h5>
    </div>
  );
}
